var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { createSiweMessage, generateAuthSig } from '@lit-protocol/auth-helpers';
import { PKPEthersWallet } from '@lit-protocol/pkp-ethers';
import { ethers } from 'ethers';
export var getSwieAuthSigFromSessionSig = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var signer, startTime, toSign, _c, _authSig;
    var _d;
    var pkp = _b.pkp, litNodeClient = _b.litNodeClient, sessionSig = _b.sessionSig, sessionLength = _b.sessionLength;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                signer = new PKPEthersWallet({
                    pkpPubKey: pkp.publicKey,
                    controllerSessionSigs: sessionSig,
                    rpc: process.env.NEXT_PUBLIC_LIT_RPC,
                    provider: new ethers.providers.JsonRpcProvider(process.env.NEXT_PUBLIC_LIT_RPC),
                    litNodeClient: litNodeClient,
                });
                startTime = new Date();
                _c = createSiweMessage;
                _d = {
                    walletAddress: pkp === null || pkp === void 0 ? void 0 : pkp.ethAddress
                };
                return [4 /*yield*/, litNodeClient.getLatestBlockhash()];
            case 1: return [4 /*yield*/, _c.apply(void 0, [(_d.nonce = _e.sent(),
                        _d.expiration = new Date(Date.now() + sessionLength * 1000).toISOString(),
                        _d)])];
            case 2:
                toSign = _e.sent();
                console.log('WUJI: toSign time', new Date().getTime() - startTime.getTime());
                startTime = new Date();
                return [4 /*yield*/, generateAuthSig({
                        signer: signer,
                        toSign: toSign,
                    })];
            case 3:
                _authSig = _e.sent();
                console.log('WUJI: generateAuthSig time', new Date().getTime() - startTime.getTime());
                return [2 /*return*/, _authSig];
        }
    });
}); };
